import { create } from 'zustand'

const useCompetitiveStore = create((set) => ({
  price_symbol: '',
  competitive: [
    {
      isLoading: true,
    },
    {
      isLoading: true,
    },
    {
      isLoading: true,
    },
    {
      isLoading: true,
    },
    {
      isLoading: true,
    },
  ],
  setField: (field, value) => set((state) => ({ ...state, [field]: value })),
  init: () =>
    set((state) => ({
      ...state,
      price_symbol: '',
      competitive: [
        {
          isLoading: true,
        },
        {
          isLoading: true,
        },
        {
          isLoading: true,
        },
        {
          isLoading: true,
        },
        {
          isLoading: true,
        },
      ],
    })),
}))

export default useCompetitiveStore
